import { render } from "./PrimaryDashboard.vue?vue&type=template&id=590b58e6&scoped=true"
import script from "./PrimaryDashboard.vue?vue&type=script&lang=js"
export * from "./PrimaryDashboard.vue?vue&type=script&lang=js"

import "./PrimaryDashboard.vue?vue&type=style&index=0&id=590b58e6&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590b58e6"]])

export default __exports__